// 把获取到的数据通过调用JSON.parse()方法转换成对象
export const isJSON = s => {
  try {
    JSON.parse(s)
  } catch (e) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/index.js